export default __webpack_public_path__ + "static/media/NoResultsIcon.9d2384aa.svg";